export default "__VITE_ASSET__ef1c7035__"